import { render, staticRenderFns } from "./PackageRoomSelectSection.vue?vue&type=template&id=0b1797b0"
import script from "./PackageRoomSelectSection.vue?vue&type=script&lang=js"
export * from "./PackageRoomSelectSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports